import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule, DoBootstrap, ErrorHandler } from '@angular/core';
import { safeDefineCustomElement } from 'lib-shared';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LandingModule } from './module/landing/landing.module';
import { LandingComponent } from './module/landing/landing.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorLogService, GlobalErrorHandler } from './error-log.service';
import { httpInterceptorProviders } from '../app/module/middleware';
import { LoggingService } from './module/shared/services/logging.service';
import { ApphostService } from './module/shared/services/app-host.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
    LandingModule,
    AppRoutingModule,
    FontAwesomeModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideHttpClient(withInterceptorsFromDi()),
    httpInterceptorProviders,
    ErrorLogService,
    LoggingService,
    ApphostService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule implements DoBootstrap {
  constructor(
    private injector: Injector,
    private router: Router,
  ) {}

  ngDoBootstrap() {
    const customEl = createCustomElement(AppComponent, { injector: this.injector });
    safeDefineCustomElement('finra-app-tess', customEl);

    const customElLanding = createCustomElement(LandingComponent, { injector: this.injector });
    safeDefineCustomElement('finra-tess-dashboard', customElLanding);

    this.router.initialNavigation();
  }
}
